module.exports = __webpack_public_path__ + "img/pantalla 4-1.c0025fd3.svg";